/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortform_Replacement_TableInputs */

const en_shortform_replacement_table = /** @type {(inputs: Shortform_Replacement_TableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shortform Replacement Table`)
};

const fr_shortform_replacement_table = /** @type {(inputs: Shortform_Replacement_TableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Table des remplacements d'abréviations`)
};

const de_shortform_replacement_table = /** @type {(inputs: Shortform_Replacement_TableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kurzform-Ersatztabelle`)
};

const it_shortform_replacement_table = /** @type {(inputs: Shortform_Replacement_TableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tabella di sostituzione abbreviata`)
};

const ru_shortform_replacement_table = /** @type {(inputs: Shortform_Replacement_TableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Таблица замены кратких форм`)
};

const es_shortform_replacement_table = /** @type {(inputs: Shortform_Replacement_TableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tabla de reemplazo de formato corto`)
};

const zh_cn2_shortform_replacement_table = /** @type {(inputs: Shortform_Replacement_TableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`简式替换表`)
};

const ja_shortform_replacement_table = /** @type {(inputs: Shortform_Replacement_TableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`短縮形置換表`)
};

const hi_shortform_replacement_table = /** @type {(inputs: Shortform_Replacement_TableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`संक्षिप्त प्रतिस्थापन तालिका`)
};

const pt_pt2_shortform_replacement_table = /** @type {(inputs: Shortform_Replacement_TableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tabela de Substituição de Formato Abreviado`)
};

/**
* | output |
* | --- |
* | "Shortform Replacement Table" |
*
* @param {Shortform_Replacement_TableInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortform_replacement_table = /** @type {((inputs?: Shortform_Replacement_TableInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortform_Replacement_TableInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_shortform_replacement_table(inputs)
	if (locale === "de") return de_shortform_replacement_table(inputs)
	if (locale === "it") return it_shortform_replacement_table(inputs)
	if (locale === "ru") return ru_shortform_replacement_table(inputs)
	if (locale === "es") return es_shortform_replacement_table(inputs)
	if (locale === "zh-CN") return zh_cn2_shortform_replacement_table(inputs)
	if (locale === "ja") return ja_shortform_replacement_table(inputs)
	if (locale === "hi") return hi_shortform_replacement_table(inputs)
	if (locale === "pt-PT") return pt_pt2_shortform_replacement_table(inputs)
	return en_shortform_replacement_table(inputs)
});